module.exports = __webpack_public_path__ + "static/media/ios-download-badge.a89300cc.svg";